<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Müşteri Trafikleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
        details:[],
        search: true,
        title: "MÜŞTERİ TRAFİKLERİ",
        items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "MÜŞTERİ TRAFİKLERİ",
          active: true,
        },
      ],
      isLoading: false,
      detailSearch:true,
      form:{},
      ilList: [],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {
        },
        sort: [
          {
            field: '',
            type: '',
          },
        ],
        page: 1,
        perPage: 50,
      },
      currentPage: 0,
      selected: 0,
      pageLength: 0,
        url: "reports/trafik",
        paginationOptions: {
        enabled: true,
        dropdownAllowAll: false,
        perPage: 50,
        setCurrentPage: 1,
        perPageDropdown: [50, 100, 200],
        nextLabel: 'Sonraki',
        prevLabel: 'Önceki',
        rowsPerPageLabel: 'Kayıt Göster',
        ofLabel: 'of',
        pageLabel: 'sayfa', // for 'pages' mode
        infoFn: params => `Bulunduğun Sayfa ${params.currentPage}`,
      },
      columns: [
        {
          label: 'Kullanıcı Adı',
          field: 'username',
          sortable: false,
        },
        {
          label: 'Servisi',
          field: 'tariff_name',
          sortable: false,
        },
         {
          label: 'Online Süre',
          field: 'acctsessiontime',
          sortable: false,
        },
        {
          label: 'Upload',
          field: 'acctinputoctets',
          sortable: false,
        },
        {
          label: 'Download',
          field: 'acctoutputoctets',
          sortable: false,
        },
         {
          label: 'İlçe',
          field: 'district_name',
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.ilListesi()
  },
  methods: {
     async ilListesi(){
        const response = await this.$http.post(`/address/il/0`)
        this.ilList = response.data;
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
        this.info = response.info
      
      })
    },
    getFromServer() {
      return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              info: res.data.info,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    formSubmit(){
      this.updateParams({columnFilters : {...this.form}});
      this.loadItems()
    },
    tariff(a){
        this.$http.post('/tariff/getByGroup', { groupName : a.target.value ,output:'only'})
        .then(resp => {
            this.list.tariffs = resp.data.content
        })
        .catch(error => error)
    },
 
    excelExport() {
      this.$http.post('/reports/export/sales',  {...this.form})
      .then((response) => {
          var temp = 'data:application/vnd.ms-excel;base64,'
              +encodeURIComponent(response.data.content);  
          var download = document.createElement('a');  
          download.href = temp;  
          download.download = response.data.filename;  
          document.body.appendChild(download);  
          download.click();
          document.body.removeChild(download);
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

     <div class="row mb-3">
        <div class="col-md-6 offset-lg-6 text-end">
           <div class="button-items mx-2">
           
             <button 
                class="btn btn-outline-light bg-light" 
                :class="{ activeClass: detailSearch }"
                type="button"  
                @click="detailSearch = !detailSearch">
                <i class="bx bx-filter-alt"></i> Detaylı Arama
            </button>
          </div>
      </div>
     <Transition  name="fade" v-if="detailSearch">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <form class="needs-validation" @submit.prevent="formSubmit">
                <div class="row">
                  
                  <div class="col-xl-3">
                    <div class="mb-3">
                      <label>Tür</label>
                      <select v-model="form.tur" class="form-select">
                        <option value="adsl">Adsl</option>
                        <option value="wifi">Wireless</option>
                      </select>
                    </div>
                  </div>

                   <div class="col-xl-3">
                    <div class="mb-3">
                      <label>İlçe</label>
                      <select v-model="form.ilce" class="form-select">
                        <option v-for="(iller,i) in ilList" :value="iller.id" :key="i">{{ iller.name }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-xl-2">
                    <div class="row">
                      <div class="col-md-12 mb-3">
                        <label>-</label>
                        <div class="button-items">
                            <button 
                              type="submit"
                              class="btn btn-primary w-100 "   
                              >
                              Sorgula
                            </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- end card -->
          </div>
        </div>
      </div>
    </Transition>
      <!-- end col -->
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :line-numbers="true"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{enabled: false}"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>